import { Text } from '@chakra-ui/react';

import SectionStartTemplate from '../../../templates/sectionStart';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

export interface IProps {
  config: any;
}

const InterviewSectionStart = (props: IProps) => {
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      hideProgress={true}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
      section={props.config.SectionStart.title}
      minsToComplete={15}
    >
      <Text fontSize={'lg'}>Answer a few questions about your upcoming overseas study.</Text>
    </SectionStartTemplate>
  );
};

export default InterviewSectionStart;
